import { extend } from 'sk-ui/lib/utils/util.js'
import { action } from 'sky-engine/api'

import AddFeishuUserByEmail from './metaData/AddFeishuUserByEmail'

import ChangeRole from '../../../components/ChangeRole'

import { USER } from '@/api'

// import lang from '@/lang'
export default {
  UmRelationUser({ commit }, props) {
    import('./metaData/relationUser').then(metaData => {
      const metaDataCopy = extend(true, {}, metaData.default)
      metaDataCopy.view.columns[0] = {
        props: {
          type: 'radio',
          width: 55
        }
      }
      this.dispatch('OpenRelationDialog', { metaData: metaDataCopy, props, clone: false })
    })
  },
  UmRelationUserList({ commit }, props) {
    import('./metaData/relationUser').then(metaData => {
      const metaDataCopy = extend(true, {}, metaData.default)
      this.dispatch('OpenRelationDialog', { metaData: metaDataCopy, props, clone: false })
    })
  },
  changeRoleMenuByAdmin({ commit }, params) {
    var dialog = this._vm.$dialog({
      template: h => {
        return (
          <change-role
            onCb={function() {
              dialog.remove()
            }}
          ></change-role>
        )
      },
      components: {
        ChangeRole
      },
      props: {
        title: '当前所处角色变更',
        width: '35%',
        'custom-class': 'custom-change-detail-dialog',
        showCancelBtn: false, // 隐藏取消按钮
        showClose: false, // 隐藏关闭按钮
        showDefaultFooter: false, //隐藏确定和取消按钮
        closeOnPressEscape: false, // 不能通过ESC键关闭
        closeOnHashChange: false // 不能通过路由改变关闭
      }
    })
  },
  AddHandelFeiShuUser({ commit }, params) {
    const props = {
      params: {}
    }
    this.dispatch('OpenFullDialog', { metaData: AddFeishuUserByEmail, props, clone: false })
    // this.dispatch('OpenDialogForm', {
    //   metaData: AddFeishuUserByEmail,
    //   props,
    //   dialogProps: {
    //     title: '手动根据邮箱添加用户',
    //     width: '35%',
    //     cbOk: () => {
    //       params.viewController.fetch()
    //       this.$store.dispatch('RemoveDialogMetaData', true)
    //     }
    //   }
    // })
  },
  SyncFeiShuUser({ commit }, params, props) {
    params.viewController.loading = true
    action(USER, 'syncFeiShuUser', {})
      .then(response => {
        params.viewController.loading = false
        this.dispatch('OpenNotification', { message: '同步飞书用户信息成功', type: 'success' })
      })
      .catch(e => {
        params.viewController.loading = false
        throw e
      })
  },
  SyncChannelUser({ commit }, params, props) {
    params.viewController.loading = true
    action(USER, 'syncChannelUser', {})
      .then(response => {
        params.viewController.loading = false
        this.dispatch('OpenNotification', { message: '同步渠道用户信息成功', type: 'success' })
      })
      .catch(e => {
        params.viewController.loading = false
        throw e
      })
  }
}
